export default {"src":"/_next/static/media/audio-doc.9aae3d78.svg","height":40,"width":40};